import{getAuth as t}from"../utils/authHelper.js";import"../utils/common.js";import"../constants/index.js";import"axios";var o=function(){if("undefined"!=typeof window){var o=t();return(null==o?void 0:o.token)?{Authorization:"Bearer "+o.token}:{}}return{}};export{o as default};
//# sourceMappingURL=auth.header.js.map
